import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const MyAnimation = () => {
  return (
    <div style={{ width: "350px", height: "500px", overflow: "hidden" }}>
      <DotLottieReact
        src="https://lottie.host/10eedd0f-ee93-41f5-82f0-bd91fc381eed/zYZdT5yhRH.lottie"
        loop
        autoplay
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};
export default MyAnimation;
